import { gql } from "@apollo/client";

export const CREATE_COURSE = gql`
  mutation createCourse($input: CreateCourseInput!) {
    createCourse(input: $input) {
      success
      message
      record {
        id
        course_name
        status
        created_by_name
        created_at
      }
    }
  }
`;

export const UPDATE_COURSE = gql`
  mutation updateCourse($input: UpdateCourseInput!) {
    updateCourse(input: $input) {
      success
      message
      record {
        id
        course_name
        status
        updated_at
      }
    }
  }
`;

export const DELETE_COURSE = gql`
  mutation deleteCourse($input: DeleteCourseInput!) {
    deleteCourse(input: $input) {
      success
      message
      record {
        id
        course_name
        status
        updated_at
      }
    }
  }
`;

export const CREATE_SUBJECT = gql`
  mutation createSubject($input: CreateSubjectInput!) {
    createSubject(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        created_by_name
        created_at
      }
    }
  }
`;

export const DELETE_SUBJECT = gql`
  mutation deleteSubject($input: DeleteSubjectInput!) {
    deleteSubject(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        updated_at
      }
    }
  }
`;

export const UPDATE_SUBJECT = gql`
  mutation updateSubject($input: UpdateSubjectInput!) {
    updateSubject(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        updated_at
      }
    }
  }
`;

export const CREATE_CHAPTER = gql`
  mutation createChapter($input: CreateChapterInput!) {
    createChapter(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        created_by_name
        created_at
      }
    }
  }
`;

export const DELETE_CHAPTER = gql`
  mutation deleteChapter($input: DeleteChapterInput!) {
    deleteChapter(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        updated_at
      }
    }
  }
`;

export const UPDATE_CHAPTER = gql`
  mutation updateChapter($input: UpdateChapterInput!) {
    updateChapter(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        updated_at
      }
    }
  }
`;

export const CREATE_TOPIC = gql`
  mutation createTopic($input: CreateTopicInput!) {
    createTopic(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        created_by_name
        created_at
      }
    }
  }
`;

export const UPDATE_TOPIC = gql`
  mutation updateTopic($input: UpdateTopicInput!) {
    updateTopic(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        updated_at
      }
    }
  }
`;

export const DELETE_TOPIC = gql`
  mutation deleteTopic($input: DeleteTopicInput!) {
    deleteTopic(input: $input) {
      success
      message
      record {
        id
        global_name
        status
        updated_at
      }
    }
  }
`;

export const CREATE_COURSE_CLASS_SUBJECT_CHAPTER_MAPPING = gql`
  mutation CreateCourseClassSubjectChapterMapping(
    $input: CreateCourseClassSubjectChapterMappingInput!
  ) {
    createCourseClassSubjectChapterMapping(input: $input) {
      success
      message
      record {
        id
        global_course_id
        class_id
        global_subject_id
        global_chapter_id
        is_program_hierarchy_enabled
        is_course_hierarchy_enabled
        status
        created_at
        created_by_id
        created_by_name
        updated_at
        updated_by_id
        updated_by_name
      }
    }
  }
`;

export const DELETE_COURSE_CLASS_SUBJECT_CHAPTER_MAPPING = gql`
  mutation DeleteCourseClassSubjectChapterMapping(
    $input: DeleteCourseClassSubjectChapterMappingInput!
  ) {
    deleteCourseClassSubjectChapterMapping(input: $input) {
      success
      message
      record {
        id
        global_course_id
        class_id
        global_subject_id
        global_chapter_id
        is_program_hierarchy_enabled
        is_course_hierarchy_enabled
        status
        created_at
        created_by_id
        created_by_name
        updated_at
        updated_by_id
        updated_by_name
      }
    }
  }
`;

export const CREATE_COURSE_CLASS_SUB_CHAP_TOPIC_MAP = gql`
  mutation createCourseClassSubjectChapterTopicMapping(
    $input: CreateCourseClassSubjectChapterTopicInput!
  ) {
    createCourseClassSubjectChapterTopicMapping(input: $input) {
      success
      message
      record {
        id
        global_course_id
        class_id
        global_subject_id
        global_chapter_id
        global_topic_id
        status
        created_by_name
        created_at
      }
    }
  }
`;

export const DELETE_COURSE_CLASS_SUB_CHAP_TOPIC_MAP = gql`
  mutation deleteCourseClassSubjectChapterTopicMapping(
    $input: DeleteCourseClassSubjectChapterTopicInput!
  ) {
    deleteCourseClassSubjectChapterTopicMapping(input: $input) {
      success
      message
      record {
        id
        global_course_id
        class_id
        global_subject_id
        global_chapter_id
        global_topic_id
        status
        updated_at
      }
    }
  }
`;
